import type { ILanguageProviderProps } from 'kfone-frontend-core/interfaces';
import translationDE from './de/translation.json';
import translationEN from './en/translation.json';
import translationES from './es/translation.json';
import translationFR from './fr/translation.json';
import translationTH from './th/translation.json';
import translationJA from './ja/translation.json';
import translationVI from './vi/translation.json';
import translationZH from './zh/translation.json';
import translationID from './id/translation.json';
import translationPT from './pt/translation.json';
import translationZH_TW from './zh-TW/translation.json';

const getLanguageResources = (): ILanguageProviderProps => ({
  resources: {
    en: {
      translation: {
        ...((translationEN as any) ?? {}),
      },
    },
    de: {
      translation: {
        ...((translationDE as any) ?? {}),
      },
    },
    es: {
      translation: {
        ...((translationES as any) ?? {}),
      },
    },
    fr: {
      translation: {
        ...((translationFR as any) ?? {}),
      },
    },
    id: {
      translation: {
        ...((translationID as any) ?? {}),
      },
    },
    ja: {
      translation: {
        ...((translationJA as any) ?? {}),
      },
    },
    pt: {
      translation: {
        ...((translationPT as any) ?? {}),
      },
    },
    th: {
      translation: {
        ...((translationTH as any) ?? {}),
      },
    },
   
    vi: {
      translation: {
        ...((translationVI as any) ?? {}),
      },
    },
    zh: {
      translation: {
        ...((translationZH as any) ?? {}),
      },
    },
    'zh-TW': {
      translation: {
        ...((translationZH_TW as any) ?? {}),
      },
    }     
  },
  translationId: 'en',
});

export default getLanguageResources;
